import { Heart, Play, Users, Calendar, Leaf } from 'lucide-react';
import { motion } from 'framer-motion';

import aboutYogaSanctuary from '../../assets/about_yoga_sanctuary.jpg';
export default function HeroSection() {
  return (
    <section id="about-hero" className="relative overflow-hidden bg-white !pt-0 sm:!pt-1 !pb-2 sm:!pb-3" style={{ paddingTop: "0px", paddingBottom: "8px" }}>


      <div className="max-w-[1320px] mx-auto px-5 sm:px-8 relative z-10">
        <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-12 lg:gap-14 items-start pt-1 sm:pt-2">
          
          {/* Left Column — Text & Stat Badges */}
          <motion.div
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="flex flex-col items-start"
          >
            {/* Eyebrow Label */}
            <span className="font-mono text-[12px] sm:text-[12.5px] tracking-[0.16em] uppercase text-[#9E7B3B] font-bold inline-flex items-center gap-2 before:content-[''] before:w-5 before:h-[1.5px] before:bg-[#9E7B3B] mb-4">
              About MetaFit Wellness
            </span>

            {/* Main Headline */}
            <h1 className="font-serif font-bold text-4xl sm:text-5xl lg:text-[54px] text-[#15302B] leading-[1.08] tracking-[-0.02em] mb-4 relative">
              Wellness that feels{' '}
              <span className="text-[#185243] italic font-serif font-normal block sm:inline">
                calm, premium, and personal
              </span>

            </h1>

            {/* Subtitle Description */}
            <p className="text-[#5C6E66] text-base sm:text-[17px] leading-relaxed max-w-[560px] mb-8">
              We combine ancient practice with modern care to help you build strength, serenity, and a sustainable wellness routine that fits real life.
            </p>

            {/* Action Buttons */}
            <div className="flex flex-wrap items-center gap-4 mb-10">
              <a
                href="/founder"
                style={{ color: '#ffffff' }}
                className="inline-flex items-center gap-2.5 rounded-full bg-[#183B30] hover:bg-[#122E25] px-7 py-3.5 !text-white font-semibold text-[14.5px] shadow-md transition-all hover:scale-[1.02]"
              >
                <div className="w-5 h-5 rounded-full bg-white/20 flex items-center justify-center shrink-0">
                  <Play size={11} fill="#ffffff" stroke="#ffffff" className="ml-0.5" />
                </div>
                <span style={{ color: '#ffffff' }} className="!text-white font-semibold">Explore Founder's Story</span>
              </a>

              <a
                href="/contact"
                className="inline-flex items-center gap-2 rounded-full border border-[#D5CDBD] bg-white/80 hover:bg-white px-7 py-3.5 text-[#183B30] font-semibold text-[14.5px] transition-all shadow-sm"
              >
                Talk to Us
              </a>
            </div>

            {/* 3 Stat Badges Row */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3.5 w-full">
              {/* Badge 1: Guided Sessions */}
              <div className="rounded-2xl border border-[#EBE4D5] bg-white/80 backdrop-blur-sm p-4 flex items-center gap-3.5 shadow-sm">
                <div className="w-11 h-11 rounded-full bg-[#E5F3EE] text-[#2C6B56] flex items-center justify-center shrink-0">
                  <Users className="w-5 h-5" />
                </div>
                <div>
                  <div className="text-[10px] font-bold uppercase tracking-[0.12em] text-[#7A8A82]">
                    GUIDED SESSIONS
                  </div>
                  <div className="text-[16px] sm:text-[17px] font-bold text-[#15302B] font-serif leading-tight mt-0.5">
                    1:1 + group
                  </div>
                </div>
              </div>

              {/* Badge 2: Founding Year */}
              <div className="rounded-2xl border border-[#EBE4D5] bg-white/80 backdrop-blur-sm p-4 flex items-center gap-3.5 shadow-sm">
                <div className="w-11 h-11 rounded-full bg-[#E5F3EE] text-[#2C6B56] flex items-center justify-center shrink-0">
                  <Calendar className="w-5 h-5" />
                </div>
                <div>
                  <div className="text-[10px] font-bold uppercase tracking-[0.12em] text-[#7A8A82]">
                    FOUNDING YEAR
                  </div>
                  <div className="text-[16px] sm:text-[17px] font-bold text-[#15302B] font-serif leading-tight mt-0.5">
                    2023
                  </div>
                </div>
              </div>

              {/* Badge 3: Community Impact */}
              <div className="rounded-2xl border border-[#EBE4D5] bg-white/80 backdrop-blur-sm p-4 flex items-center gap-3.5 shadow-sm">
                <div className="w-11 h-11 rounded-full bg-[#E5F3EE] text-[#2C6B56] flex items-center justify-center shrink-0">
                  <Leaf className="w-5 h-5" />
                </div>
                <div>
                  <div className="text-[10px] font-bold uppercase tracking-[0.12em] text-[#7A8A82]">
                    COMMUNITY IMPACT
                  </div>
                  <div className="text-[16px] sm:text-[17px] font-bold text-[#15302B] font-serif leading-tight mt-0.5">
                    5000+ lives
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Column — Organic Curved Image Card */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="relative w-full max-w-[440px] mx-auto lg:ml-auto"
          >
            {/* Ambient Background Aura */}
            <div className="absolute -inset-4 rounded-[32px] bg-[radial-gradient(circle_at_top_right,rgba(44,107,86,0.22),transparent_55%)] blur-2xl pointer-events-none" />

            {/* Main Rounded Image Container */}
            <div className="relative overflow-hidden rounded-[24px] sm:rounded-[32px] border border-[#E2D8C6] shadow-[0_16px_36px_-12px_rgba(21,48,43,0.2)] bg-white">
              <img
                src={aboutYogaSanctuary}
                alt="Woman practicing mindful yoga in a peaceful natural wellness sanctuary"
                className="w-full h-[280px] sm:h-[330px] lg:h-[360px] object-cover"
              />

              {/* Floating Overlay Badge: 5000+ Lives Transformed */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="absolute bottom-4 right-4 sm:bottom-5 sm:right-5 bg-white/95 backdrop-blur-md border border-[#E2D8C6] rounded-xl sm:rounded-2xl p-2.5 sm:p-3 px-3.5 sm:px-4 shadow-lg flex items-center gap-3"
              >
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-[#D9F0E6] text-[#2C6B56] flex items-center justify-center shrink-0">
                  <Heart className="w-4 h-4 sm:w-5 sm:h-5 fill-[#2C6B56] text-[#2C6B56]" />
                </div>
                <div>
                  <div className="text-lg sm:text-xl font-bold text-[#15302B] font-serif leading-none">
                    5000+
                  </div>
                  <div className="text-[11px] sm:text-[11.5px] text-[#6A7A75] font-medium mt-0.5">
                    Lives transformed
                  </div>
                </div>
              </motion.div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
